import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import initActionCreators from '../../redux/TimetablesRedux';
import { SEARCH_MODE } from '../../services/TimetablesService';
import RouteSearch from '../../components/RouteSearch/RouteSearchComponent';
import Header from './components/Header';
import StopsTimetable from './components/StopsTimetable';
import SchoolBusButton from './components/SchoolBusButton';
import SurveyButton from '../../components/SurveyButton/SurveyButton';
import Notice from './components/DataNotice';
import { CATEGORIES, TIMETABLES_ACTION, logEvent } from '../../services/AnalyticsService';


// --------------- Stop Listing - MainContainer ----------------------------------------------------
const bem = 'tt-main';
const SURVEY_URL = process.env.SURVEY_TIME_TABLES_URL || 'https://aucklandtransport.au1.qualtrics.com/jfe/form/SV_3OW9ddFnKtem9Fj';

class TimeTablesContainer extends React.PureComponent {
  onSelectLongname(shapeId) {
    const { selectedHeadsign, retrieveStopsRequest } = this.props;
    const foundRoute = selectedHeadsign.routes.filter(r => r.shape_ids === shapeId);
    logEvent(CATEGORIES.TIMETABLES, TIMETABLES_ACTION.ROUTE_SELECT, foundRoute[0].trip_headsign);
    retrieveStopsRequest(foundRoute[0]);
  }

  onSelectStop = (...args) => {
    const { selectStopRequest } = this.props;
    logEvent(CATEGORIES.TIMETABLES, TIMETABLES_ACTION.STOP_SELECT, `route: ${args[1]}; stop: ${args[2]}`);
    selectStopRequest(...args);
  };

  searchModeClass = (searchMode) => {
    switch (searchMode) {
      case SEARCH_MODE.BUS:
        return 'search-bus';
      case SEARCH_MODE.TRAIN:
        return 'search-train';
      case SEARCH_MODE.FERRY:
        return 'search-ferry';
      default:
        return '';
    }
  };

  _onDismissSurvey = () => {
    const { dismissSurvey } = this.props;
    dismissSurvey(true);
  };

  _renderDetailFooter = (showDetail) => {
    const {
      searchMode, surveyDismissed,
    } = this.props;
    const isBusMode = searchMode && searchMode === SEARCH_MODE.BUS;
    const classNameSurveyButton = `timetable-survey ${isBusMode ? 'timetable-survey-bus' : ''}`;
    return (
      <div className={`row ${bem}__footer`}>
        <div className="col-xs-offset-1 col-xs-10 col-sm-offset-3 col-sm-6">
          {isBusMode && <SchoolBusButton />}
        </div>
        <SurveyButton
          display={!surveyDismissed && showDetail}
          onClose={this._onDismissSurvey}
          href={SURVEY_URL}
          className={classNameSurveyButton}
        />
      </div>
    );
  };


  render() {
    const { selectedHeadsign, searchMode, timetables } = this.props;
    const showDetail = !!selectedHeadsign;
    const { route_short_name: routeShortName } = (selectedHeadsign || {});
    const searchModeClass = this.searchModeClass(searchMode);
    const hiddenMobile = !!timetables;
    return (
      <div className="main-content-container">
        <div className={`at-flex-grid ${bem}`}>
          { /* Route Search Component */ }
          <div className={`row ${hiddenMobile ? 'hidden-mobile' : ''} ${searchModeClass}`}>
            <div className="col-xs-offset-1 col-xs-10 col-sm-offset-3 col-sm-6 route-search-container">
              <div className={`${bem}__route-search`}>
                <RouteSearch />
              </div>
            </div>
          </div>
          <div className="row">
            <Notice />
          </div>
          {
            showDetail && (
              <div className={`${bem}__detail`}>
                <div className={`row ${bem}__detail-header`}>
                  <div className="col-xs-12 col-sm-12">
                    <Header
                      {...this.props}
                      onRouteDropdownChange={shapeId => this.onSelectLongname(shapeId)}
                    />
                  </div>
                </div>

                <div className={`row ${bem}__detail-stop-timetable`}>
                  <div className="col-xs-12 col-sm-12">
                    <StopsTimetable
                      {...this.props}
                      onClickStop={this.onSelectStop}
                      routeShortName={routeShortName}
                    />
                  </div>
                </div>
              </div>
            )
          }
          {this._renderDetailFooter(showDetail)}
        </div>
      </div>
    );
  }
}

/* ------------- Prop Types Definitions  ------------- */
TimeTablesContainer.defaultProps = {
  selectedHeadsign: null,
};
TimeTablesContainer.propTypes = {
  retrieveStopsRequest: PropTypes.func.isRequired,
  dismissSurvey: PropTypes.func.isRequired,
  selectedHeadsign: PropTypes.object,
  stops: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
};

/* ------------- Redux mappings  ------------- */
const mapDispatchToProps = dispatch => ({
  dispatch,
});

const mapStateToProps = (state) => {
  const searchMode = state.timetables.searchMode;
  const searchModeState = state.timetables[searchMode];
  return {
    searchMode,
    selectedHeadsign: searchModeState.selectedHeadsign,
    selectedRoute: searchModeState.selectedRoute,
    stops: searchModeState.stops,
    loadingStops: searchModeState.loadingStops,
    timetables: searchModeState.timetables, // TODO: Its confusing when parent/child have the same name. Rename this!!
    selectedDayIndex: searchModeState.selectedDayIndex,
    selectedStop: searchModeState.selectedStop,
    changeDaySelector: searchModeState.changeDaySelector,
    loadingTimetable: searchModeState.loadingTimetable,
    surveyDismissed: searchModeState.surveyDismissed,
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;
  const { searchMode } = stateProps;
  const actionCreators = initActionCreators(searchMode);
  return {
    ...ownProps,
    ...stateProps,
    retrieveStopsRequest: route => dispatch(actionCreators.retrieveStopsRequest(route)),
    selectStopRequest: (...args) => dispatch(actionCreators.selectStopRequest(...args)),
    changeDaySelector: (...args) => dispatch(actionCreators.changeDaySelector(...args)),
    clearTimetable: (...args) => dispatch(actionCreators.clearTimetable(...args)),
    gotoLiveDepartureRequest: (...args) => dispatch(actionCreators.gotoLiveDepartureRequest(...args)),
    dismissSurvey: surveyDismissed => dispatch(actionCreators.dismissSurvey(surveyDismissed)),
  };
};

const reduxComponent = connect(mapStateToProps, mapDispatchToProps, mergeProps)(TimeTablesContainer);
export default withRouter(reduxComponent);
